export default "../../src/img/futurehome.png";